import { useState } from "react"
import { Container, TextAreaContainer } from "./styles"

const TextArea = ({ failed, failMessage, label, ...props}) => {

    const [isFocus, setIsFocus] = useState(false)
    const [isFilled, setIsFilled] = useState(false)

    const handleOnFocus = () => {
        setIsFilled(false)
        setIsFocus(true)
    }

    const handleOnBlur = (event) => {
        setIsFocus(false)
        setIsFilled(!!event.target.value)
    }

    return (
        <Container>
            <TextAreaContainer isFocus={isFocus} isFilled={isFilled} failed={failed}>
                <textarea
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    {...props}
                    required
                />
                <label>{label}</label>
            </TextAreaContainer>
            {failed && <span>{failMessage}</span>}
        </Container>
    )
}

export default TextArea